module.exports = __webpack_public_path__ + "img/42.e3dbe323.jpg";